import React, { useState } from 'react';

const ClassPasswordModal = ({ isOpen, onSubmit, onClose, classKey, className }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Get password for the class from env
  const getClassPassword = () => {
    if (!classKey) return '';
    return process.env[`REACT_APP_${classKey}`] || '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setError('Please enter the class password');
      return;
    }
    console.log(password, getClassPassword());
    if (password === getClassPassword()) {
      setError('');
      setPassword('');
      onSubmit(true);
    } else {
      setError('Incorrect password!');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            {className ? `${className} - Password Required` : 'Class Password Required'}
          </h2>
          <p className="text-gray-600">Enter the password to access this class.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="classPassword" className="block text-sm font-medium text-gray-700 mb-2">
              Class Password
            </label>
            <input
              type="password"
              id="classPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter class password"
              autoFocus
            />
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <div className="flex gap-3 pt-2">
            <button
              type="submit"
              className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClassPasswordModal;
